"use client";

import { useLocale, useTranslations } from "use-intl";

import { TelegramIcon } from "@/components/icons/telegram-icon";
import { Button } from "@/components/ui/button";
import { setLocale } from "@/i18n/actions";
import { trackLoginStarted, trackSignupStarted } from "@/lib/analytics";
import { authClient } from "@/lib/auth-client";
import {
  buildTelegramSignupOnboardingHrefWithRedirect,
  getRedirectAfterLogin,
} from "@/lib/redirect-after-login";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function TelegramAuthButton({
  mode,
  redirectAfterLogin,
}: {
  mode: "signin" | "signup";
  redirectAfterLogin?: string;
}) {
  const t = useTranslations("globals.auth");
  const locale = useLocale() as ViewerLocale;

  return (
    <Button
      type="button"
      variant="outline"
      className="h-12 w-full gap-2 text-base"
      size="lg"
      onClick={async () => {
        if (mode === "signup") {
          trackSignupStarted("telegram", "method");
        } else {
          trackLoginStarted("telegram", "method");
        }
        const redirect = getRedirectAfterLogin(redirectAfterLogin);
        await setLocale({ data: locale });
        return authClient.signIn.social({
          provider: "telegram-oidc",
          callbackURL: redirect,
          newUserCallbackURL: buildTelegramSignupOnboardingHrefWithRedirect(redirect),
        });
      }}
    >
      <TelegramIcon className="size-5 text-[#229ED9]" />
      {t("continueWithTelegram", { mode })}
    </Button>
  );
}
